import {
  getClickCancelOOPModalEvent,
  getClickContinueOOPModalEvent,
  getConfigTenant,
  getShowOOPModalEvent,
  isCorpTenant,
  SHOW_POLICIES_IN_PACKAGES,
  useShowPolicyBanner,
} from "@capone/common";
import { Box, Typography } from "@material-ui/core";
import {
  BackToTopButton,
  HotelShopRoomTypePickerEnum,
  HotelShopRoomTypePickerVariant,
  Icon,
  IconName,
  PackageHotelShopRoomTypePicker,
  PricingDisplayModeEnum,
  TrackingEventControlType,
  SanitizedHtml,
} from "halifax";
import React, { useContext, useEffect, useRef } from "react";
import { RouteComponentProps } from "react-router";
import {
  ModalScreens,
  SELECT_PACKAGE_HOTEL_ROOM,
  ViewedCorpRateDescriptorEntryPoints,
} from "redmond";
import { useExperimentIsVariant } from "@capone/experiments";
import {
  useExperiments,
  getExperimentVariant,
  PACKAGES_LIST_OPTIMIZATIONS_V1,
  getExperimentVariantCustomVariants,
  PACKAGES_PRICING_DISPLAY,
  PACKAGES_PRICING_DISPLAY_VARIANTS,
  CHANGE_PER_TRAVELER,
} from "../../../../context/experiments";
import { ClientContext } from "../../../../App";
import { config } from "../../../../api/config";
import { trackEvent } from "../../../../api/v0/analytics/trackEvent";

// import { TravelWalletDetailsBanner } from "../../../travel-wallet/components/TravelWalletDetailsBanner";
import { getEarnTagText } from "../../textConstants";
// import { MobileShopHeader } from "../MobileShopHeader";
import { MobileRoomPickerConnectorProps } from "./container";
import { onOpenCompareBarTooltip } from "../../../../utils/events";
import "./styles.scss";
import { MobileShopHeader } from "../MobileShopHeader";
import { AVAILABLE } from "../../../../context/experiments";

export interface IMobileRoomPickerProps
  extends MobileRoomPickerConnectorProps,
    RouteComponentProps {
  roomInfoProductsType?: HotelShopRoomTypePickerVariant;
  handleReadyToRedirect?: (
    trackingEventControl?: TrackingEventControlType
  ) => void;
  nonRefundablePolicyOverrideText?: string;
}

export const MobileRoomPicker = (props: IMobileRoomPickerProps) => {
  const {
    checkinDate,
    checkoutDate,
    chosenProduct,
    selectRoomType,
    // selectedLodging,
    chosenRoomInfoIndex,
    handleReadyToRedirect,
    roomInfoProductsType,
    canEarnRewards,
    selectedAccount,
  } = props;
  const isFirstUpdate = useRef<boolean>(true);

  const showEarnEnhancement =
    !!selectedAccount &&
    !!selectedAccount.earn.hotelsMultiplier &&
    canEarnRewards;

  const { isAutoApprovalEnabled, policies } = useContext(ClientContext);

  const modalType = isAutoApprovalEnabled
    ? "out_of_policy_auto"
    : "out_of_policy";

  const showPolicyBanner =
    SHOW_POLICIES_IN_PACKAGES && useShowPolicyBanner(policies);

  const { experiments } = useExperiments();
  const packagesPricingDisplayVariant = getExperimentVariantCustomVariants(
    experiments,
    PACKAGES_PRICING_DISPLAY,
    PACKAGES_PRICING_DISPLAY_VARIANTS
  );
  const isCorpHotelRoomRatesDesignTestEnabled = useExperimentIsVariant(
    "corp-hotel-room-rates-design-test-v1",
    AVAILABLE
  );
  const packagesListEnhancementsEnabled =
    getExperimentVariant(experiments, PACKAGES_LIST_OPTIMIZATIONS_V1) ===
    AVAILABLE;

  useEffect(() => {
    if (checkinDate && checkoutDate) {
      // skip the first update
      if (isFirstUpdate.current) {
        isFirstUpdate.current = false;
      }
    }
  }, [checkinDate, checkoutDate]);

  useEffect(() => {
    !chosenProduct && selectRoomType(0, 0);
    setTimeout(() => {
      const id = "chosen-room";
      const yOffset = -122.5;
      const element = document.getElementById(id);
      const y =
        (element?.getBoundingClientRect().top ?? 0) +
        window.pageYOffset +
        yOffset;
      if (chosenRoomInfoIndex || chosenRoomInfoIndex === 0) {
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }, 50);
  }, []);
  // const [showOfferBanner, setShowOfferBanner] = useState(false);

  const showGlobalMobileNavExperience = !isCorpTenant(getConfigTenant());

  return (
    <Box>
      <MobileShopHeader />
      {/* {showOfferBanner && (
        <TravelWalletDetailsBanner
          onDismiss={() => setShowOfferBanner(false)}
          offer={selectedLodging?.bestOfferThisLodging!}
          className="mobile-hotel-shop-offer"
          screen={SelectedTravelOfferScreen.HOTEL_DETAILS}
          bannerTextType="shop"
        />
      )} */}
      <PackageHotelShopRoomTypePicker
        {...props}
        roomInfoProductsType={
          roomInfoProductsType ?? {
            roomInfoProducts: props.roomInfoProducts,
            variant: HotelShopRoomTypePickerEnum.Default,
          }
        }
        isMobile
        className="b2b"
        onClickContinue={(
          room_type?: string,
          in_policy?: boolean,
          hotel_loyalty_eligible?: boolean,
          is_corporate?: boolean
        ) => {
          if (handleReadyToRedirect) {
            const room =
              props.chosenRoomInfo && props.chosenRoomInfo.roomInfo.name;
            handleReadyToRedirect({
              [SELECT_PACKAGE_HOTEL_ROOM]: {
                properties: {
                  room_type: room ?? room_type,
                  provider_name: props.chosenProduct?.providerName,
                  rate_provider: props.chosenProduct?.providerName,
                  ...(isCorpTenant(config.TENANT) && {
                    in_policy,
                    hotel_loyalty_eligible,
                    is_corporate,
                  }),
                },
              },
            });
          }
        }}
        earnTagContent={
          showEarnEnhancement ? (
            <>
              <Icon name={IconName.StarIcon} />
              <SanitizedHtml
                as={Typography}
                className="earn-tag-text"
                html={getEarnTagText(
                  selectedAccount.earn.hotelsMultiplier,
                  selectedAccount.rewardsBalance.currencyDescription ??
                    selectedAccount.rewardsBalance.currency
                )}
              />
            </>
          ) : undefined
        }
        earnTagClassName={showEarnEnhancement ? "b2b" : undefined}
        variant="refundable-room-ux"
        onShowOutOfPolicyModal={() =>
          trackEvent(
            getShowOOPModalEvent(ModalScreens.HOTELS_SHOP, "hotels", modalType)
          )
        }
        onClickOutOfPolicyContinue={() =>
          trackEvent(
            getClickContinueOOPModalEvent(
              ModalScreens.HOTELS_SHOP,
              "packages",
              modalType
            )
          )
        }
        onClickOutOfPolicyCancel={() =>
          trackEvent(
            getClickCancelOOPModalEvent(
              ModalScreens.HOTELS_SHOP,
              "packages",
              modalType
            )
          )
        }
        isGlobalMobileNavExperiment={showGlobalMobileNavExperience}
        onViewCorpCompareBar={onOpenCompareBarTooltip(
          ViewedCorpRateDescriptorEntryPoints.HOTELS_ROOM_DETAILS
        )}
        showPolicyBanner={showPolicyBanner}
        rewardsAccount={selectedAccount}
        isCorpHotelRoomRatesDesignTestEnabled={
          isCorpHotelRoomRatesDesignTestEnabled
        }
        showEnhancedPackagePricing={packagesListEnhancementsEnabled}
        pricingDisplayMode={
          packagesPricingDisplayVariant === CHANGE_PER_TRAVELER
            ? PricingDisplayModeEnum.ChangePerTraveler
            : PricingDisplayModeEnum.TotalPerTraveler
        }
      />

      <BackToTopButton />
    </Box>
  );
};
